import { ListItemButton, styled } from '@mui/material';

export const StyledListItemButton = styled(ListItemButton)({
  fontSize: '16px',
  '&.Mui-selected': {
    color: '#145DA0',
    backgroundColor: '#fff',
    fontWeight: '500',
    '&::before': {
      content: '""',
      width: '4px',
      height: '25px',
      backgroundColor: '#145DA0',
      position: 'absolute',
      left: '0',
    },
  },
});

export const StyledSubListItemButton = styled(ListItemButton)({
  fontSize: '16px',
  marginLeft: '16px',
  '&.Mui-selected': {
    color: '#145DA0',
    backgroundColor: '#fff',
    fontWeight: '500',
  },
});
